import PropTypes from 'prop-types';
import React from 'react';
import {FormControl, Button} from 'react-bootstrap';
import './LoginBox.scss';

function LoginBox(props) {
  const {
    logoIconSrc,
    logoIconAlt,
    logoTextSrc,
    logoTextAlt,
    logoFooterSrc,
    logoFooterAlt,
    version,
    year,
    isRestoringState,
    isRestoringMessage,
    isRestoringRestoreButtonText,
    isRestoringNewStateButtonText,
    username,
    password,
    loginButtonText,
    onUsernameChange,
    onUsernameKeyPressEnter,
    onPasswordChange,
    onPasswordKeyPressEnter,
    onLoginClick,
    onRestoreClick,
    onNewStateClick,
    isTessaraInstrument,
    logoTessaraSrc,
    logoTessaraAlt,
  } = props;

  const onUsernameKeyPressEnterHandler = (e) => {
    if (e.key !== 'Enter') {
      return;
    }

    onUsernameKeyPressEnter();
  };

  const onPasswordKeyPressEnterHandler = (e) => {
    if (e.key !== 'Enter') {
      return;
    }

    onPasswordKeyPressEnter();
  };

  const renderContent = () => {
    if (!isRestoringState) {
      return (
        <div>
          <div className="form-group has-feedback">
            <FormControl
              type="text"
              placeholder="Username"
              value={username}
              onChange={onUsernameChange}
              autoFocus
              onKeyPress={onUsernameKeyPressEnterHandler}
            />
            <span className="glyphicon glyphicon-user form-control-feedback" />
          </div>
          <div className="form-group has-feedback">
            <FormControl
              type="password"
              placeholder="Password"
              value={password}
              onChange={onPasswordChange}
              onKeyPress={onPasswordKeyPressEnterHandler}
            />
            <span className="glyphicon glyphicon-lock form-control-feedback" />
          </div>
          <div className="row">
            <div>
              <Button bsStyle="primary" bsSize="large" onClick={onLoginClick}>
                {loginButtonText}
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="restore">
        <div className="form-group has-feedback">{isRestoringMessage}</div>
        <div className="row">
          <div>
            <Button bsStyle="primary" bsSize="large" onClick={onRestoreClick}>
              {isRestoringRestoreButtonText}
            </Button>
          </div>
          <div>
            <Button bsStyle="default" bsSize="large" onClick={onNewStateClick}>
              {isRestoringNewStateButtonText}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="login-box-container">
      <div className="login-box">
        <div className="login-box-body">
          <div className="row">
            <div className="logo">
              <img src={logoIconSrc} alt={logoIconAlt} style={{display: 'inline-block', margin: '0 10px 0 5px'}} />
              <img src={logoTextSrc} alt={logoTextAlt} style={{width: '73%', display: 'inline-block'}} />
            </div>
          </div>
          <div className="form-group has-feedback">
            <span> </span>
          </div>
          {renderContent()}
        </div>
        <div className={`login-box-footer ${isTessaraInstrument ? 'tessara' : ''}`}>
          {isTessaraInstrument ? (
            <>
              <div className="login-box-footer__top">
                <img height={30} src={logoTessaraSrc} alt={logoTessaraAlt} />
                <img src={logoFooterSrc} alt={logoFooterAlt} />
              </div>
              <div className="login-box-footer__bottom">
                <div className="login-box-footer__version">{version}</div>
                <div className="login-box-footer__year">{year}</div>
              </div>
            </>
          ) : (
            <>
              <div className="login-box-footer__version">{version}</div>
              <div className="login-box-footer__formulatrix">
                <img src={logoFooterSrc} alt={logoFooterAlt} />
              </div>
              <div className="login-box-footer__year">{year}</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

LoginBox.propTypes = {
  logoIconSrc: PropTypes.string,
  logoIconAlt: PropTypes.string,
  logoTextSrc: PropTypes.string,
  logoTextAlt: PropTypes.string,
  logoFooterSrc: PropTypes.string,
  logoFooterAlt: PropTypes.string,
  logoTessaraSrc: PropTypes.string,
  logoTessaraAlt: PropTypes.string,
  version: PropTypes.string,
  year: PropTypes.string,
  isRestoringState: PropTypes.bool,
  isRestoringMessage: PropTypes.any,
  isRestoringRestoreButtonText: PropTypes.string,
  isRestoringNewStateButtonText: PropTypes.string,
  username: PropTypes.string,
  password: PropTypes.string,
  loginButtonText: PropTypes.string,
  isTessaraInstrument: PropTypes.bool,
  onUsernameChange: PropTypes.func,
  onUsernameKeyPressEnter: PropTypes.func,
  onPasswordChange: PropTypes.func,
  onPasswordKeyPressEnter: PropTypes.func,
  onLoginClick: PropTypes.func,
  onRestoreClick: PropTypes.func,
  onNewStateClick: PropTypes.func,
};

LoginBox.defaultProps = {
  logoIconSrc: './svg/login/fast-icon.svg',
  logoIconAlt: 'FAST Icon',
  logoTextSrc: './svg/login/fast-text.svg',
  logoTextAlt: 'Fast Liquid Handler',
  logoFooterSrc: './svg/login/formulatrix.svg',
  logoFooterAlt: 'Formulatrix Logo',
  logoTessaraSrc: './svg/login/tessara.svg',
  logoTessaraAlt: 'Tessara',
  version: '1.0.0.0',
  year: '2020',
  isRestoringState: false,
  isRestoringMessage: (
    <>
      <p>The FAST system has detected that your previous session is still active.</p>
      <p>Do you want to restore the previous session?</p>
    </>
  ),
  isRestoringRestoreButtonText: 'YES, RESTORE',
  isRestoringNewStateButtonText: 'NO THANKS',
  username: '',
  password: '',
  loginButtonText: 'SIGN IN',
  isTessaraInstrument: false,
  onUsernameChange: () => {},
  onUsernameKeyPressEnter: () => {},
  onPasswordChange: () => {},
  onPasswordKeyPressEnter: () => {},
  onLoginClick: () => {},
  onRestoreClick: () => {},
  onNewStateClick: () => {},
};

export default LoginBox;
